import { createContext } from "react";

import type { TopBarOverrideContextValue } from "./types";

export const TopBarOverrideContext =
  createContext<TopBarOverrideContextValue | null>(null);
TopBarOverrideContext.displayName = "TopBarOverrideContext";
